// extracted by mini-css-extract-plugin
export default {"chatOpeningHours":"ChatOpeningHours_chatOpeningHours__dgjCm","spaceBetween":"ChatOpeningHours_spaceBetween__Eg1+T"};